import { render } from "./SolutionPage.vue?vue&type=template&id=19758cae&scoped=true"
import script from "./SolutionPage.vue?vue&type=script&lang=js"
export * from "./SolutionPage.vue?vue&type=script&lang=js"

import "./SolutionPage.vue?vue&type=style&index=0&id=19758cae&scoped=true&lang=css"

import exportComponent from "/Users/yinhu/code/jugu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19758cae"]])

export default __exports__